import { createSlice } from '@reduxjs/toolkit'

export const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    volumeDiscountCount: 0,
    products: [],
    useAltPayment: false,
    altPaymentType: '',
    altPaymentDetails: {},
    note: '',
    amount: null,
    startDate: null,
    dateConfirmed: false
  },
  reducers: {
    addProduct: (state, action) => {
      let tmp = Object.assign(
        { cartID: Math.random(), student: 'default' },
        action.payload
      )
      let price = action.payload.priceInfo.unit_amount
      if (price > 0) {
        state.volumeDiscountCount += 1
      }
      state.products.push(tmp)
    },
    removeProduct: (state, action) => {
      state.products = state.products.filter(
        (item) => item.cartID !== action.payload.cartID
      )
      let price = action.payload.priceInfo.unit_amount
      if (price > 0) {
        state.volumeDiscountCount -= 1
      }
    },
    assignStudent: (state, action) => {
      state.products = state.products.map((x) =>
        x.cartID === action.payload.product
          ? { ...x, student: action.payload.student }
          : x
      )
    },
    initLocalCart: (state, action) => {
      state.products = action.payload
      let discountCount = action.payload.filter((prod) => prod.priceInfo.unit_amount > 0)
      state.volumeDiscountCount = discountCount.length
    },
    clearCart: (state, action) => {
      state.products = []
      state.volumeDiscountCount = 0
    },
    setUseAltPayment: (state, action) => {
      state.useAltPayment = action.payload
    },
    setAltPaymentType: (state, action) => {
      state.altPaymentType = action.payload
    },
    setAltPaymentDetails: (state, action) => {
      state.altPaymentDetails = action.payload
    },
    setNote: (state, action) => {
      state.note = action.payload
    },
    setAmount: (state, action) => {
      state.amount = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {
  addProduct,
  removeProduct,
  assignStudent,
  initLocalCart,
  clearCart,
  setUseAltPayment,
  setAltPaymentType,
  setAltPaymentDetails,
  setNote,
  setAmount
} = cartSlice.actions

export default cartSlice.reducer
